import { render, staticRenderFns } from "./VaimoPhone.vue?vue&type=template&id=13ca8948&scoped=true&"
import script from "./VaimoPhone.vue?vue&type=script&lang=ts&"
export * from "./VaimoPhone.vue?vue&type=script&lang=ts&"
import style0 from "./VaimoPhone.vue?vue&type=style&index=0&id=13ca8948&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ca8948",
  null
  
)

export default component.exports